import AlarmMsg from '@/utils/alarmMsg';
import axios from 'axios';

// 핸드폰 번호 하이픈 넣기
export function addMobileHyphen(hp) {
	return hp.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/, '$1-$2-$3');
}

// 핸드폰 번호 하이픈 넣기 (실시간)
export function addMobileHyphenReadTime(str) {
	str = str.replace(/[^0-9]/g, '');
	var tmp = '';
	if (str.length < 4) {
		return str;
	} else if (str.length < 7) {
		tmp += str.substr(0, 3);
		tmp += '-';
		tmp += str.substr(3);
		return tmp;
	} else if (str.length < 11) {
		tmp += str.substr(0, 3);
		tmp += '-';
		tmp += str.substr(3, 3);
		tmp += '-';
		tmp += str.substr(6);
		return tmp;
	} else {
		tmp += str.substr(0, 3);
		tmp += '-';
		tmp += str.substr(3, 4);
		tmp += '-';
		tmp += str.substr(7);
		return tmp;
	}
}

/**
 * 숫자 형태의 데이터를 받아 Hyphen(-) 을 붙여서 치환
 * @param {String|Number} num - hyphen(-)이 없는 숫자 형태의 데이터
 * @return {string|string} hyphen(-)이 붙은 숫자 형태의 String 데이터
 */
export function addHyphenNumber(num) {
	if (!num) return;
	const numStr = String(num);
	if (numStr?.length === 11) return numStr?.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3') ?? '';
	if (numStr?.length === 8) return numStr?.replace(/(\d{4})(\d{4})/, '$1-$2') ?? '';
	if (numStr?.indexOf('02') === 0) return numStr?.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3') ?? '';
	return String(num)?.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3') ?? '';
}

// 날짜 하이픈 넣기 (실시간)
export function addDateHyphenReadTime(str) {
	var retVal;
	// debugger

	if (str !== undefined && String(str) !== '') {
		var regExp = /[{}\[\]\/?.,;:|)*~`!^\-_+<>@#$%&\\=('"]/gi;

		var tmp = String(str)
			.replace(/(^\s*)|(\s*$)/gi, '')
			.replace(regExp, ''); // 공백 및 특수문자 제거

		if (tmp.length <= 4) {
			retVal = tmp;
		} else if (tmp.length > 4 && tmp.length <= 6) {
			retVal = tmp.substr(0, 4) + '-' + tmp.substr(4, 2);
		} else if (tmp.length > 6 && tmp.length <= 8) {
			retVal = tmp.substr(0, 4) + '-' + tmp.substr(4, 2) + '-' + tmp.substr(6, 2);
		} else {
			return str;
		}
	} else {
		return str;
	}

	return retVal;
}

// 콤마 넣기
export function numberWithCommas(x) {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

// 날짜 포맷 변경 - Date > String
// param: Data(), format: ex) '-': '2019-11-11' , '.': '2019.11.11', 'kor': '2019년 11월 11일', ....
export function getFormatDate(date, format, timeYn) {
	let ymFm = '';
	let mdFm = '';
	let dFm = '';
	if (typeof format === 'string') {
		if (format === 'kor') {
			ymFm = '년 ';
			mdFm = '월 ';
			dFm = '일';
		} else {
			ymFm = format;
			mdFm = format;
			dFm = format;
		}
	}

	let year;
	let month;
	let day;

	if (typeof date === 'string') {
		date = date.replace(/[^0-9]/gi, '');

		year = date.substr(0, 4);
		month = date.substr(4, 2);
		day = date.substr(6, 2);
	} else {
		year = date.getFullYear();
		month = 1 + date.getMonth();
		month = month >= 10 ? month : '0' + month;
		day = date.getDate();
		day = day >= 10 ? day : '0' + day;
	}

	// 시간 포함 여부
	let time;
	if (timeYn === 'Y') {
		let hour;
		let min;

		if (typeof date === 'string') {
			hour = date.substr(8, 2);
			min = date.substr(10, 2);
		} else {
			hour = date.getHours();
			min = date.getMinutes();

			hour = hour >= 10 ? hour : '0' + hour;
			min = min >= 10 ? min : '0' + min;
		}

		time = ' ' + hour + ':' + min;
	}
	return year + ymFm + month + mdFm + day + dFm + time;
}

// 날짜 비교 함수
export function getDateDiff(_date1, _date2) {
	var diffDate_1 = _date1 instanceof Date ? _date1 : new Date(_date1);
	var diffDate_2 = _date2 instanceof Date ? _date2 : new Date(_date2);

	diffDate_1 = new Date(diffDate_1.getFullYear(), diffDate_1.getMonth() + 1, diffDate_1.getDate());
	diffDate_2 = new Date(diffDate_2.getFullYear(), diffDate_2.getMonth() + 1, diffDate_2.getDate());

	var diff = diffDate_2.getTime() - diffDate_1.getTime();
	diff = Math.ceil(diff / (1000 * 3600 * 24));

	return diff;
}

// 특정 영역 인쇄
// param: 해당영역 id, style(String), popWidth(int), popHeigth(int)
export function framePrint(id, style, popWidth, popHeight) {
	/** 팝업 */
	let printDiv = document.getElementById(id);
	let inputArr = printDiv.getElementsByTagName('input');
	let inputValues = [];
	for (let i = 0; i < inputArr.length; i++) {
		inputValues[i] = inputArr[i].value;
	}
	let innerHtml = document.getElementById(id).innerHTML; // 프린트 할 특정 영역 복사

	for (let i = 0; i < inputArr.length; i++) {
		innerHtml = innerHtml.replace('<input class', '<input value="' + inputValues[i] + '" class');
	}

	// 스타일 링크 걸어줌
	let styleLink = '';
	for (let i = 0; i < style.link.length; i++) {
		styleLink += '<link href="' + style.link[i] + '" rel="prefetch" />';
	}

	let pWidth = popWidth || 700;
	let pHeight = popHeight || 800;
	let popupWindow = window.open('', '_blank', 'width=' + pWidth + ',height=' + pHeight);
	popupWindow.document.write(
		'<!DOCTYPE html>' +
			'<html lang="ko">' +
			'<head>' +
			styleLink +
			'<style>' +
			style.str +
			'</style>' +
			'<title></title></head>' +
			'<body>' +
			innerHtml +
			'</body>' +
			'</html>'
	);

	popupWindow.document.close();
	popupWindow.focus();

	// 지정영역 인쇄 안함
	let noPrint = popupWindow.document.getElementsByClassName('noPrint');
	for (let i = 0; i < noPrint.length; i++) {
		noPrint[i].remove();
	}

	/** 1초 지연 */
	setTimeout(() => {
		popupWindow.print(); // 팝업의 프린트 도구 시작
		popupWindow.close(); // 프린트 도구 닫혔을 경우 팝업 닫기
	}, 1000);
}

/* 숫자만 입력 - keypress, keydown */
export function onlyNoPress(eventKey) {
	return !(eventKey.length === 1 && '1234567890'.indexOf(event.key) === -1);
}

/* 숫자만 입력 keyup */
export function onlyNoUp(value) {
	return value.replace(/[^0-9]/gi, '');
}

/**
 * 첨부파일 업로드 시 File 타입 체크
 *
 * @param files   {File} 첨부파일
 * @param typeArr {Array} 첨부 가능한 확장자
 * @param size    {Number} 첨부 제한 크기
 * @param type    {String} 현재 페이지 이름
 *
 * @description
 * - 기존 PC 버전 함수에 빈 파일 체크 알림 추가
 */
export function chkOnFileChange(files, size, typeArr, type) {
	if (!files.length) {
		// 파일 없음
		AlarmMsg.showMsg('빈 파일입니다. 빈 파일은 업로드 할 수 없습니다.');
		return false;
	} else {
		// 용량 체크
		var fileSize = files[0].size;
		var maxSize = size * 1024 * 1024;
		if (fileSize > maxSize) {
			if (type === 'apiwrite') {
				AlarmMsg.showMsg('잘못된 파일입니다. PDF, JPG, PNG로 2MB 이하로 등록 가능합니다.');
			} else if (type === 'qnawrite') {
				AlarmMsg.showMsg('잘못된 파일입니다. ' + typeArr.join(', ') + '로 ' + size + 'MB 이하로 등록 가능합니다.');
			} else {
				AlarmMsg.showMsg('첨부파일 업로드는 최대 ' + size + 'MB까지 가능합니다.');
			}
			return false;
		}

		// 파일 타입 체크 - png, pdf, jpg, jpeg, docx, doc, ppt, pptx, xls, xlsx, zip
		const agreeFileType = typeArr || [
			'png',
			'pdf',
			'jpg',
			'jpeg',
			'img',
			'docx',
			'doc',
			'ppt',
			'pptx',
			'xls',
			'xlsx',
			'zip',
		];
		const fileNm = files[0].name;
		const fileExt = fileNm.substr(fileNm.lastIndexOf('.') + 1);
		let chkBool = false;
		for (let i in agreeFileType) {
			if (agreeFileType[i].toLowerCase() === fileExt.toLowerCase()) {
				chkBool = true;
			}
		}
		if (!chkBool) {
			if (type === 'api') {
				AlarmMsg.showMsg('첨부파일은 pdf, jpg, png, ppt, pptx, doc, docx 만 가능합니다.');
			} else if (type === 'apiwrite') {
				AlarmMsg.showMsg('잘못된 파일입니다. PDF, JPG, PNG로 2MB 이하로 등록 가능합니다.');
			} else if (type === 'qnawrite') {
				AlarmMsg.showMsg('잘못된 파일입니다. ' + typeArr.join(', ') + '로 ' + size + 'MB 이하로 등록 가능합니다.');
			} else {
				AlarmMsg.showMsg('지원하지 않는 파일입니다.');
			}
			return false;
		}

		return true;
	}
}

/**
 * @description [업로드 파일 유효성 체크]
 * @description 빈(0 byte) 파일 여부 확인 / 최대 파일 사이즈 확인 / 파일 중복 확인
 * @description 단일 파일을 입력받아, 전체(File[ ])와 비교하여 파일 업로드 유효성 검사
 *
 * @param file                  {File}  업로드 파일(단일 File)
 * @param size                  {Number} 최대 업로드 가능한 파일 크기 (MB 단위) - 기본값 : 5 (0 이하일경우, 검사 X)
 * @param fileExtensionArr      {String[]} 업로드 가능한 확장자 목록 ex) ['pdf', 'jpg', 'jpeg', 'png', 'gif', 'docx', 'doc', 'ppt', 'pptx', 'xls', 'xlsx', 'zip']
 * @param uploadedFileList      {File[]} 업로드된 파일 전체 목록
 * @returns {boolean}
 * @constructor
 */
export function checkInvalidUploadFile(file, { size = 5, fileExtensionArr = [], uploadedFileList = [] } = {}) {
	// file 은 필수(없는 경우 false return)
	if (!file) return false;

	if (!file.size) {
		// 파일 크기 0byte
		AlarmMsg.showMsg('빈 파일입니다. 빈 파일은 업로드 할 수 없습니다.');
		return false;
	}

	// 업로드 파일 용량 확인 ( 0일 경우, 검사하지 않음)
	if (size > 0) {
		const maxSize = size * 1024 * 1024;
		const totalFileSize = [...uploadedFileList, file].reduce((prev, f) => prev + f.size, 0);

		// 파일 크기 제한
		if (totalFileSize > maxSize) {
			AlarmMsg.showMsg(
				`파일의 확장자 또는 용량을 다시 확인해 주세요.
        ${fileExtensionArr.join(', ')}로 ${size}MB 이하 파일 등록 가능합니다.
        `
			);
			return false;
		}
	}

	// 파일명 추출
	const fileNm = file.name;
	// 파일 확장자 추출
	const fileExt = fileNm.substr(fileNm.lastIndexOf('.') + 1);

	// 업로드 가능한 파일 확장자 체크
	if (fileExtensionArr.length > 0) {
		// 업로드 하고자 하는 파일의 확장자와 허용된 확장자 목록과 비교하여 하나라도 일치하는 항목이 없을 경우
		if (fileExtensionArr.every(ext => ext !== fileExt)) {
			AlarmMsg.showMsg(
				`파일의 확장자 또는 용량을 다시 확인해 주세요.
        ${fileExtensionArr.join(', ')}로 ${size}MB 이하 파일 등록 가능합니다.
        `
			);
			return false;
		}
	}

	// 기존 파일들 중 중복하는 이름의 파일이 있는지 체크
	if (uploadedFileList.length > 0) {
		if (uploadedFileList.some(f => f.name === fileNm)) {
			AlarmMsg.showMsg('중복된 이름의 첨부파일이 이미 존재합니다. \n 다른 파일을 선택해주세요.');
			return false;
		}
	}

	return true;
}

/**
 * 파일 용량 확인
 * @param {File | File[]} file
 * @returns {number} 파일크기 (bytes)
 */
export function getFileSize(file) {
	if (!file) return 0;
	if (file.length) {
		return [...file].reduce((prev, f) => prev + f.size, 0);
	}
	return file.size;
}

/**
 * 이미지파일 크기(가로, 세로) 값 확인
 * @async
 * @param {File | File[]} file
 * @returns {Promise<{width: number; height: number;}>}
 */
export async function getImageFileSize(file) {
	return new Promise((resolve, reject) => {
		const img = document.createElement('img');
		img.onload = () => {
			const width = img.naturalWidth;
			const height = img.naturalHeight;
			resolve({ width, height });
		};
		img.onerror = reject;
		img.src = window.URL.createObjectURL(file);
	});
}

class FileValidationError extends Error {
	constructor(type, message) {
		super(message);
		this.type = type;
	}
}

/**
 * 파일 유효성 확인
 * @async
 *
 * @param {File} file
 * @param {object} options
 * @param {number} options.minSize 최대 허용 Bytes
 * @param {number} options.maxSize 최대 허용 Bytes
 * @param {string[]} options.extensions 허용 확장자 목록
 * @param {number} options.imageWidth 이미지 너비
 * @param {number} options.imageHeight 이미지 높이
 * @returns {true}
 * @throws
 */
export async function isValidFile(
	file,
	{ minSize, maxSize, extensions, imageWidth, imageHeight, maxImageWidth, maxImageHeight } = {}
) {
	if (!file) throw new FileValidationError('exist', 'file is not exist');

	if (minSize && file.size < minSize) {
		throw new FileValidationError('minSize', 'less than the minimum size');
	}

	if (maxSize && maxSize < file.size) {
		throw new FileValidationError('maxSize', 'overflow than maximum size');
	}

	if (imageWidth) {
		let width = 0;
		try {
			width = (await getImageFileSize(file)).width;
		} catch (error) {
			throw new FileValidationError('isNotImage', 'is not image file');
		}
		if (imageWidth !== width) throw new FileValidationError('imageWidth', 'width does not match');
	}

	if (imageHeight) {
		let height = 0;
		try {
			height = (await getImageFileSize(file)).height;
		} catch (error) {
			throw new FileValidationError('isNotImage', 'is not image file');
		}
		if (imageHeight !== height) throw new FileValidationError('imageHeight', 'height does not match');
	}

	if (maxImageWidth) {
		let width = 0;
		try {
			width = (await getImageFileSize(file)).width;
		} catch (error) {
			throw new FileValidationError('isNotImage', 'is not image file');
		}
		if (maxImageWidth < width) throw new FileValidationError('maxImageWidth', 'overflow than maxImageWidth');
	}

	if (maxImageHeight) {
		let height = 0;
		try {
			height = (await getImageFileSize(file)).height;
		} catch (error) {
			throw new FileValidationError('isNotImage', 'is not image file');
		}
		if (maxImageHeight < height) throw new FileValidationError('maxImageHeight', 'overflow than maxImageHeight');
	}

	if (extensions?.length) {
		const fileExt = file.name.substr(file.name.lastIndexOf('.') + 1);
		if (extensions.every(ext => ext !== fileExt)) {
			throw new FileValidationError('extensions', 'is not allowed extension');
		}
	}

	return true;
}

/**
 * 파일 유효성 확인 (Alert 메시지 처리 포함)
 * @async
 *
 * @param {File} file
 * @param {object} options
 * @param {number} options.minSize 최대 허용 Bytes
 * @param {number} options.maxSize 최대 허용 Bytes
 * @param {string[]} options.extensions 허용 확장자 목록
 * @param {number} options.imageWidth 이미지 너비
 * @param {number} options.imageHeight 이미지 높이
 * @returns {boolean}
 */
export async function isValidFileWithMessage(file, options) {
	try {
		return isValidFile(file, options);
	} catch (error) {
		if (error.type === 'exist') {
			AlarmMsg.showMsg('파일이 존재하지 않습니다.');
		}
		if (error.type === 'minSize') {
			AlarmMsg.showMsg(`파일이 최소 용량보다 작습니다. 최소 ${options.minSize}Bytes`);
		}
		if (error.type === 'maxSize') {
			AlarmMsg.showMsg(`파일이 용량을 초과하였습니다. 최대 ${options.maxSize}Bytes`);
		}
		if (error.type === 'extensions') {
			AlarmMsg.showMsg('허용되지 않은 확장자입니다.');
		}
		if (error.type === 'isNotImage') {
			AlarmMsg.showMsg('이미지 파일이 아닙니다.');
		}
		if (error.type === 'imageWidth') {
			AlarmMsg.showMsg(`너비가 ${options.imageWidth}px인 파일만 등록 가능합니다.`);
		}
		if (error.type === 'imageHeight') {
			AlarmMsg.showMsg(`높이가 ${options.imageHeight}px인 파일만 등록 가능합니다.`);
		}
		return false;
	}
}

/**
 * URL 통해 파일 다운로드
 * @param {String} url 다운로드 URL
 * @param {String} fileName 다운로드 파일명
 * @param {String} method 호출 방식(GET/POST) - 기본값: GET
 * @return {Promise<void>}
 */
export async function downloadFileFromUrl(url, fileName, { method = 'GET' } = {}) {
	if (!url) {
		AlarmMsg.showMsg('올바르지 않는 URL 입니다.', '알림');
		return;
	}

	const realFileName = url?.substr(url?.lastIndexOf('/') + 1, url?.length);
	if (!realFileName) {
		AlarmMsg.showMsg('해당 하는 파일을 찾을 수 없습니다.', '알림');
		return;
	}

	const fnNm = fileName ? fileName : realFileName;

	console.log(`
  [ 파일 다운로드 ]
  * URL : ${url},
  * realFileName : ${realFileName}
  * fileName : ${fnNm}
  * method : ${method}
  `);

	AlarmMsg.showMsg(`첨부 파일을 다운로드 합니다.<br>다운로드까지 조금 시간이 걸릴 수 있습니다.`, '알림');

	const response = await axios({
		url: url,
		method: method,
		responseType: 'blob',
	});

	if (response?.status !== 200) {
		AlarmMsg.showMsg('서버에서 파일을 내려 받는 중, 통신에 실패하였습니다.', '알림');
		return;
	}

	const aTagUrl = window.URL.createObjectURL(new Blob([response?.data]));
	const link = document.createElement('a');
	link.href = aTagUrl;
	link.setAttribute('download', fnNm || realFileName);
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
}

/**
 * 금액 표기 시, 3자리마다 쉼표(,) 를 붙여서 표기한다. plugins.js 의 addCommma  function 버젼
 * @param {Number} num 숫자 형태의 금액값
 * @return {string|number} 3자리마다 쉼표(,)가 붙은 String 금액 값
 */
export function addComma(num) {
	if (!num) {
		return 0;
	}
	num = String(num);
	return num.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
}

/** 배열 리스트 N개씩 나누기 (배열 추출)
 * @param {Array} items
 * @param {Number} size
 * */
export function splitArray(items, size) {
	const result = [];
	let idx = 0;
	for (idx; idx < items.length; idx += size) {
		let tempArr = items.slice(idx, idx + size);
		result.push(tempArr);
	}

	return result;
}

export function replaceSpecialToText(text) {
	if (typeof text !== 'string') return '';
	const pattern = /[^가-힣ㄱ-ㅎㅏ-ㅣa-zA-Z0-9\u{321C}()]/giu;
	return text.replace(pattern, '');
}

export async function asyncMultipleAxiosCall(targetArr, key, call, isCallBack) {
	// console.log(targetArr);
	return new Promise((resolve, reject) => {
		try {
			let res = [];
			targetArr.forEach(async (payload, idx) => {
				const { code, result } = await call({ [key]: payload });
				if (code !== 'SUC0000') {
					reject(code);
					throw new Error(code);
				}
				res = [...res, { target: payload, ...result }];
				if (isCallBack && idx + 1 === targetArr.length) resolve(res);
				if (!isCallBack && idx + 1 === targetArr.length) resolve(true);
			});
		} catch (err) {
			reject(err);
		}
	});
}

// 버전 이슈로 baeminBrCd 유지. 안정화 후에 삭제 예정
// 이후 개발은 brand.js > isCancelLimitBrCd로 사용 부탁드립니다!
export const baeminBrCd = process.env.NODE_ENV === 'development' ? 'BR00002' : 'BR12915'; // 배민 브랜드코드(BR12915) - 구매 취소 안됨

export function isIncludeText(text = '', searchText = '') {
	if (!text || !searchText) {
		return false;
	}

	return text.includes(searchText);
}

export function handleChannelTalkIconClick() {
	document.getElementById('channel_service').click();
}

export function copyClipBoard(value) {
	if (navigator.clipboard) {
		navigator.clipboard.writeText(value);
		return;
	}

	const textArea = document.createElement('textarea');
	textArea.value = value;
	document.body.appendChild(textArea);
	textArea.select();

	document.execCommand('copy');
	document.body.removeChild(textArea);
}

export const SPACE_UNICODE_LIST = [
	'\u00A0', // Non-Breaking Space
	'\u2002', // En Space
	'\u2003', // Em Space
	'\u2004', // Three-Per-Em Space
	'\u2005', // Four-Per-Em Space
	'\u2006', // Six-Per-Em Space
	'\u2007', // Figure Space
	'\u2008', // Punctuation Space
	'\u2009', // Thin Space
	'\u200A', // Hair Space
	'\u200B', // Zero Width Space
	'\u200C', // Zero Width Non-Joiner
	'\u200D', // Zero Width Joiner
	'\u202F', // Narrow No-Break Space
	'\u205F', // Medium Mathematical Space
	'\u3000', // Ideographic Space
];

export function replaceSpaceUnicodeToSpace(content) {
	if (!content) {
		return;
	}

	let replaceContent = content;
	SPACE_UNICODE_LIST.forEach(unicode => {
		replaceContent = replaceContent.replaceAll(unicode, ' ');
	});

	return replaceContent;
}
